export default {
  sample: '/admin/api/import/coolant/sample',
  ic: '/admin/api/import/coolant/ic',
  icp: '/admin/api/import/coolant/icp'
};
